import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=66f5fbbc"
import script from "./MessageBubble.ts?vue&type=script&lang=ts&external"
export * from "./MessageBubble.ts?vue&type=script&lang=ts&external"
import style0 from "../../styles/MessageBubble/message-bubble.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports